/**
 * Get Tailwind classes for grade colors (background and text)
 * @param {string} grade - The grade letter (A, B, C, D, F)
 * @returns {string} Tailwind classes for bg and text color
 */
export const getGradeColor = grade => {
  if (!grade) return "bg-base-content/10 text-base-content/40";
  switch (grade.toUpperCase()) {
    case "A": return "bg-success/20 text-success";
    case "B": return "bg-info/20 text-info";
    case "C": return "bg-warning/20 text-warning";
    case "D": return "bg-error/20 text-error";
    case "F": return "bg-error/30 text-error";
    default: return "bg-base-content/10 text-base-content/40";
  }
};

/**
 * Get Tailwind classes for grade colors including border
 * @param {string} grade - The grade letter (A, B, C, D, F)
 * @returns {string} Tailwind classes for bg, text, and border color
 */
export const getGradeColorWithBorder = grade => {
  if (!grade) return "bg-base-content/10 text-base-content/40 border-base-content/20";
  switch (grade.toUpperCase()) {
    case "A": return "bg-success/20 text-success border-success/30";
    case "B": return "bg-info/20 text-info border-info/30";
    case "C": return "bg-warning/20 text-warning border-warning/30";
    case "D": return "bg-error/20 text-error border-error/30";
    case "F": return "bg-error/30 text-error border-error/40";
    default: return "bg-base-content/10 text-base-content/40 border-base-content/20";
  }
};
